var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getData, updateData, createData } from "../../../utils/api/dataAccess";
// Get all AdministrativeRegions
export const getAdministrativeRegion = () => __awaiter(void 0, void 0, void 0, function* () {
    const url = `AdministrativeRegions/`;
    return getData(url);
});
// Create a new AdministrativeRegion
export const createAdministrativeRegion = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `AdministrativeRegions/add`;
    return createData(url, item);
});
// Update an existing AdministrativeRegion
export const updateAdministrativeRegion = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `AdministrativeRegions/update`;
    return updateData(url, item);
});
// Delete a AdministrativeRegion
export const deleteAdministrativeRegion = (item) => __awaiter(void 0, void 0, void 0, function* () {
    const url = `AdministrativeRegions/delete`;
    return updateData(url, item);
});
